import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';
// import { setReinforcementNz, setReinforcementType } from '@reducers/options/reinforcement/actions';
import { setRebarReinforcementType, setRebarReinforcementNz, setRebarReinforcementWorkingLife } from '@reducers/selectors/loads/actions';

import Input from '@components/Input';
import { APP_TYPES } from '@config';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { getTooltip } from '../../../texts/tooltips';
import { REBAR } from '@reducers/selectors/design/types';
import { APP_TEXTS } from '../../../texts/texts';

const RebarReinforcementActionType = props => (
  <div className="list-type">
    <ul className="inline-list">
      {props.buttons.map(item => (
        <li key={item.id}>
        <Tooltip content={getTooltip(item.tooltip)}>
          <button 
            className={`btn btn-light ${props.activeType === item.config.reinforcement.actionType.type ? 'ImageButton--active' : ''}`}
            onClick={() => { props.onClick(item.config); }}>
            <span className={item.icon} />
          </button>
          </Tooltip>
        </li>
      ))}
    </ul>

    <Input
      className="base-plate m-2"
      prefix="Nz"
      postfix={unitLabel(props.loadUnit)}
      id="nz"
      type="number"
      minValue={0}
      value={unitTransform(props.options.reinforcement.actionType.value).from(defaultUnits.LOAD).to(props.loadUnit)}
      onUpdate={value => {
        props.setNz(unitTransform(value, false).from(props.loadUnit).to(defaultUnits.LOAD));
      }}
    />

    {(props.design === REBAR.types.EUROCODE_2 || 
      props.design === REBAR.types.EUROCODE_2_FIRE || 
      props.design === REBAR.types.EUROCODE_2_SEISMIC || 
      props.design === REBAR.types.AS3600 ||
      props.design === REBAR.types.AS5216) && (
      <div className="d-flex mt-2 list-type">
        <b>
          {APP_TEXTS.WORKING_LIFE.Content}
        </b>

        <div className="d-flex flex-column ml-4">
          <label htmlFor="years_50">
          <input
            id="years_50"
            type="radio"
            name="years_50"
            onChange={(e) => props.setWL(50)}
            checked={props.wl === 50}
          />
          <b>
            &nbsp;
            {APP_TEXTS.WORKING_LIFE_50_YEARS.Content}
          </b>
          </label>

          <label htmlFor="years_100">
          <input
            id="years_100"
            type="radio"
            name="years_100"
            onChange={(e) => props.setWL(100)}
            checked={props.wl === 100}
          />
          <b>
            &nbsp;
            {APP_TEXTS.WORKING_LIFE_100_YEARS.Content}
          </b>
          </label>
        </div>
      
      </div>
    )}
  </div>
);

const mapState = state => ({
  options: state.options,

  buttons: state.selectors.application.rebarButtons.actionButtons,
  activeType: state.selectors.loads[APP_TYPES.REBAR_REINFORCEMENT].type,
  design: state.selectors.design[state.main.appType].design,
  wl: state.selectors.loads[APP_TYPES.REBAR_REINFORCEMENT].wl,

  loadUnit: state.main.units.load
});

const mapDispatch = dispatch => ({
  setNz: (value) => dispatch(setRebarReinforcementNz(value)),
  setWL: (value) => dispatch(setRebarReinforcementWorkingLife(value)),

  onClick: config => {
    dispatch(setRebarReinforcementType(config.reinforcement.actionType.type));
  }
});

export default connect(mapState, mapDispatch)(RebarReinforcementActionType);



// WEBPACK FOOTER //
// ./src/views/Loads/RebarReinforcementActionType/index.js